/* eslint-disable @typescript-eslint/no-explicit-any */
import { deepCopy } from '../../helpers';

/**
 * Schema update from version 16 to version 17
 * - Adds instanceRotation { x: 0, y: 0, z: 0 } to every panelItem that lacks it.
 *   This field stores per-instance rotation offsets applied on top of the catalog
 *   modelRotation, enabling users to interactively rotate individual appliances.
 */

const DEFAULT_INSTANCE_ROTATION = { x: 0, y: 0, z: 0 };

const addInstanceRotationToIsland = (island: any): void => {
	const panels = island?.panels?.children;
	if (!panels?.length) return;

	panels.forEach((panel: any) => {
		const groups = panel?.panelItemGroups?.children;
		if (!groups?.length) return;

		groups.forEach((group: any) => {
			const items = group?.items?.children;
			if (!items?.length) return;

			items.forEach((panelItem: any) => {
				if (!panelItem.instanceRotation) {
					panelItem.instanceRotation = { ...DEFAULT_INSTANCE_ROTATION };
				}
			});
		});
	});
};

export const u17 = (blueprint: any): any => {
	try {
		const updatedBlueprint = deepCopy(blueprint);
		updatedBlueprint.schemaVersion = 17;

		if (updatedBlueprint.kitchens?.children) {
			updatedBlueprint.kitchens.children.forEach((kitchen: any) => {
				const islands = kitchen.design?.islands?.children;
				if (islands?.length) {
					islands.forEach((island: any) => addInstanceRotationToIsland(island));
				}

				const obstructions = kitchen.design?.obstructions?.children;
				if (obstructions?.length) {
					obstructions.forEach((obstruction: any) => addInstanceRotationToIsland(obstruction));
				}
			});
		}

		return updatedBlueprint;
	} catch (_err) {
		return null;
	}
};
